import { render, staticRenderFns } from "./HeaderDeContasAPagar.vue?vue&type=template&id=af094ca8&scoped=true"
import script from "./HeaderDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeContasAPagar.vue?vue&type=style&index=0&id=af094ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af094ca8",
  null
  
)

export default component.exports